import { mgr, getIdentityServerBase } from '@/utils/oidc'
export function logoutFn() {
  const identityServerBase = getIdentityServerBase()
  const client_id = process.env.NODE_ENV === 'sit' ? 'js_oak_vue_uat' : 'js_oak_vue'
  const name = `oidc.user:${identityServerBase}:${client_id}`
  const token = localStorage.getItem('access_token')
  if (token) {
    Object.keys(localStorage).forEach(key => {
      // 如果键不是需要保留的键，则删除它
      if (key !== name) {
        localStorage.removeItem(key)
      }
    })
    mgr.signoutRedirect()
  }
}

